import type { RebuildInventoryFormState } from '../RebuildInventoryPage.types'

// Derives whether the rebuild form can be submitted.
//  - No mode selected -> not submittable.
//  - Event-scoped mode requires at least one event ID and an inventorySystemType.
//  - ISP-scoped mode requires at least one of tenantGroupCodes / inventorySystemType.
export function deriveRebuildInventoryValidity(
  state: RebuildInventoryFormState,
): boolean {
  if (state.mode === '') {
    return false
  }

  if (state.mode === 'event') {
    return state.sysEventIds.length > 0 && Boolean(state.inventorySystemType)
  }

  return state.tenantGroupCodes.length > 0 || Boolean(state.inventorySystemType)
}
